import { useState } from "react"
import { TooltipButton } from "@/v2-backoffice-client/components/button"
import Badge from "@/v2-backoffice-client/components/badge"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import MigrationCenterDialog from "@/v2-backoffice-client/tenant/migration/center/MigrationCenterDialog"
import type { MigrationCenterTenantRef } from "@/v2-backoffice-client/tenant/migration/center/tenant.migration.center.types"

export type UserMigrateManyButtonProps = {
  users: UserFragment[]
  /** Present on team-panel selections: pins every send to this team, so
   *  multi-team members work — the operator already picked the team. */
  tenant?: MigrationCenterTenantRef
  onCompleted?(): void
}

// Opens the Migration Center for a user-table selection (FUS-927): the
// selected users shown inside their teams (grouped by customer) with live
// migration status; sending from the dialog gives each not-yet-activated
// user the wave's single-user treatment. Without a pinning tenant, users
// with several teams fail individually with a pointer to their team's
// Fusion Login dialog.
function UserMigrateManyButton(props: UserMigrateManyButtonProps) {
  const { users, tenant, onCompleted } = props
  const [open, setOpen] = useState(false)

  return (
    <>
      <TooltipButton
        className="relative"
        isStacked
        iconSrc="key"
        variant="ghost"
        content={`Review and send Fusion login activations for ${users.length} user(s)`}
        disabled={!users.length}
        onClick={() => {
          setOpen(true)
        }}
      >
        Fusion
        <Badge
          className="absolute top-0 right-0 text-[8px] rounded-full"
          variant="neutral"
          size="tiny"
        >
          {users.length}
        </Badge>
      </TooltipButton>

      <MigrationCenterDialog
        open={open}
        onOpenChange={setOpen}
        selection={
          tenant
            ? { kind: "tenantUsers", tenant, users }
            : { kind: "users", users }
        }
        onCompleted={onCompleted}
      />
    </>
  )
}

export default UserMigrateManyButton
